var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeartrate({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 33,
    cy: 33,
    r: 33,
    fill: "#E53935",
    fillOpacity: 0.11
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.2992 45.8013C37.0562 47.4474 34.8108 48.6483 33.0457 49.2348C27.4897 47.3887 17.1716 39.4517 17.1716 30.7209C17.1716 25.8992 21.0806 21.9902 25.9023 21.9902C28.8549 21.9902 31.4662 23.4562 33.0457 25.7C33.8509 24.5534 34.9204 23.6176 36.1638 22.9719C37.4072 22.3262 38.7879 21.9894 40.189 21.9902C45.0107 21.9902 48.9197 25.8992 48.9197 30.7209C48.9197 32.1075 48.6593 33.4735 48.1998 34.7982",
    stroke: "#E53935",
    strokeWidth: 2.89474,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4265 39.4531H38.6013L40.9824 36.2783L43.3635 42.6279L45.7145 39.4531H48.9194",
    stroke: "#E53935",
    strokeWidth: 2.89474,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartrate);
export default __webpack_public_path__ + "static/media/Heartrate.e365c483e4f98f2d32813a7f6542cb93.svg";
export { ForwardRef as ReactComponent };